import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Group } from "../../members/models/Group";
import { Member } from "../../members/models/Member";
import { selectGroups, selectMembers } from "../../members/members-slice";
import { fetchGroups, fetchMembers } from "../../members/slice-extensions/members-slice-extension";

/**
 * The member directory the attendance roster resolves names from. The session details
 * page doesn't load it itself, so members/groups are fetched once when missing.
 */
export function useAttendanceDirectory(): { members: Member[]; groups: Group[] } {
  const dispatch = useAppDispatch();
  const members = useAppSelector(selectMembers);
  const groups = useAppSelector(selectGroups);

  useEffect(() => {
    if (members.length === 0) dispatch(fetchMembers());
    if (groups.length === 0) dispatch(fetchGroups());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { members, groups };
}
